module.exports = __webpack_public_path__ + "static/catalogo-impress-e1563383910760-163bdeeabf873a4f2ac89e471b561bde.jpg";